(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[63302,65250],{

/***/ 90638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14302));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: ({ error , isLoading , pastDelay  })=>{
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadableContext = __webpack_require__(16319);
const { useSyncExternalStore  } =  true ? __webpack_require__(67294) : 0;
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = (ids = [])=>{
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 97943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Facebook() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#4780c0",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_32_1514",
                style: {
                    maskType: "alpha"
                },
                width: "18",
                height: "15",
                x: "26",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26.121 10H43.208V25H26.121z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_32_1514)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M33.155 24.318h3.04v-6.881h2.12l.232-2.301h-2.353v-1.31c0-.548.116-.756.7-.756h1.653v-2.388h-2.115c-2.268 0-3.289.898-3.289 2.618v1.841h-1.586v2.329h1.586l.012 6.848z"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Facebook);


/***/ }),

/***/ 22371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Twitter() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#35a9ff",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                style: {
                    maskType: "alpha"
                },
                width: "18",
                height: "15",
                x: "26",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26.025 10H43.111999999999995V25H26.025z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_32_1513)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M26.01 22.15a10.97 10.97 0 005.135 1.374 11.06 11.06 0 005.201-1.167c1.58-.8 2.878-1.965 3.755-3.369.877-1.403 1.298-2.99 1.217-4.59a6.803 6.803 0 001.779-1.595 7.52 7.52 0 01-2.012.484c.736-.38 1.289-.984 1.553-1.697a7.756 7.756 0 01-2.22.75 3.665 3.665 0 00-1.983-.933c-.76-.111-1.54.002-2.22.32-.68.32-1.22.826-1.537 1.442a2.725 2.725 0 00-.218 1.966 11.02 11.02 0 01-3.997-.927 9.796 9.796 0 01-3.218-2.277 2.746 2.746 0 00-.38 2.234c.203.76.727 1.424 1.467 1.856a3.872 3.872 0 01-1.553-.381c-.01.715.265 1.41.777 1.966s1.228.939 2.026 1.081a4.064 4.064 0 01-1.553.055 3.1 3.1 0 001.24 1.525 3.804 3.804 0 002.022.602 7.394 7.394 0 01-2.492 1.114 7.931 7.931 0 01-2.79.168z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_32_1513",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H17.048V12.164H0z",
                        transform: "translate(26.025 11.364)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Twitter);


/***/ }),

/***/ 43808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Pinterest() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#e60023",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_32_1516",
                style: {
                    maskType: "alpha"
                },
                width: "19",
                height: "15",
                x: "25",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M25.93 10H43.016999999999996V25H25.93z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_32_1516)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M30.756 18.573a.327.327 0 00.382-.078.262.262 0 00.056-.117c.037-.14.129-.486.172-.631.043-.145.037-.263-.123-.436a2.15 2.15 0 01-.573-1.541c-.007-.505.1-1.005.314-1.47.214-.466.53-.887.929-1.239a4.177 4.177 0 011.392-.806 4.492 4.492 0 011.631-.244c2.33 0 3.607 1.29 3.607 3.01 0 2.262-1.104 4.172-2.75 4.172a1.46 1.46 0 01-.613-.103 1.331 1.331 0 01-.494-.343 1.168 1.168 0 01-.27-.509 1.1 1.1 0 01.014-.564c.26-.994.765-2.066.765-2.792.02-.15.005-.3-.045-.444a1.03 1.03 0 00-.244-.388 1.162 1.162 0 00-.4-.26 1.265 1.265 0 00-.483-.087c-.924 0-1.67.866-1.67 2.028-.006.428.088.853.277 1.245l-1.116 4.273a8.05 8.05 0 000 2.982c.004.02.014.038.03.053a.12.12 0 00.055.03.13.13 0 00.064 0 .12.12 0 00.055-.032 8.308 8.308 0 001.566-2.57c.104-.351.616-2.161.616-2.161.233.312.549.566.918.738.37.171.782.256 1.197.245 2.787 0 4.673-2.301 4.673-5.384 0-2.324-2.176-4.468-5.48-4.468-4.12 0-6.166 2.675-6.166 4.903-.056 1.34.505 2.542 1.714 2.988z"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Pinterest);


/***/ }),

/***/ 8281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Mobile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/oneElement/index.tsx
var oneElement = __webpack_require__(36895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/share/styles.module.scss
var styles_module = __webpack_require__(48378);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/blogPost/sideWidget/mobile/share/Share.tsx



const Share = ({ shareList  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: shareList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: `cursor-pointer  ${(styles_module_default())[el.name]}`,
                onClick: ()=>{
                    window.open(el.link, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");
                    return false;
                },
                children: el.icon
            }, index))
    });
};
/* harmony default export */ var share_Share = (Share);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/Facebook.tsx
var Facebook = __webpack_require__(97943);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/Twitter.tsx
var Twitter = __webpack_require__(22371);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/pinterest.tsx
var pinterest = __webpack_require__(43808);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx









function Mobile() {
    const { asPath  } = (0,router.useRouter)();
    const { blogPost , domain  } = (0,useDomainContext/* useDomainContext */.w)();
    const shareList = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {}),
            link: `https://www.facebook.com/sharer/sharer.php?u=https://${domain.name}${asPath}`,
            name: "facebook"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {}),
            link: `https://twitter.com/share?url=https://${domain.name}${asPath}`,
            name: "twitter"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(pinterest/* default */.Z, {}),
            link: `http://pinterest.com/pin/create/button/?url=https://${domain.name}${asPath}`,
            name: "pinterest"
        }, 
    ];
    const myList = [
        {
            title: "Contents",
            slug: "contents",
            content: (0,sharedUtils/* getMainTitlesNavigationFromBody */._H)(blogPost?.model.body)
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `   px-5 py-10  max-h-[80vh] flex flex-col justify-between `,
        children: [
            myList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(oneElement/* default */.Z, {
                    content: el.content
                }, index)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: `mt-4 text-sm font-bold`,
                        children: "Share"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `flex  gap-2 mt-3 justify-center  `,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(share_Share, {
                            shareList: shareList
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 36895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OneElement; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25086);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67379);



function OneElement({ content  }) {
    const { setModal  } = (0,_hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (content?.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().linksList)}      `,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-lg mt-8 mb-5 hidden lg:block ",
                    children: "Contents"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-h-[300px] overflow-y-auto",
                    children: content?.map((el, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `
                                ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bulletedListItem)} pl-5    
                                     pb-5  `,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: el?.link ?? "#",
                                dangerouslySetInnerHTML: {
                                    __html: el?.title
                                },
                                onClick: ()=>setModal({
                                        active: false,
                                        content: undefined
                                    }),
                                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().linkColor)}   block  cursor-pointer text-sm `
                            })
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 37814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Caret; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Caret() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                d: "M0 0H256V256H0z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "16",
                d: "M96 48L176 128 96 208"
            })
        ]
    });
}


/***/ }),

/***/ 31095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CombinedForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/combinedForm/style.module.scss
var style_module = __webpack_require__(34480);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/api/index.ts + 19 modules
var api = __webpack_require__(21513);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/components/shared/form/index.tsx
var shared_form = __webpack_require__(96119);
// EXTERNAL MODULE: ./src/components/shared/form/progressBar/index.tsx
var progressBar = __webpack_require__(91354);
;// CONCATENATED MODULE: ./src/components/shared/combinedForm/icons/creditRepair.tsx


function CreditRepair() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "55",
        height: "55",
        fill: "none",
        viewBox: "0 0 55 55",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                style: {
                    maskType: "alpha"
                },
                width: "55",
                height: "55",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H55V55H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2_2288)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#010101",
                        d: "M27.506 23.59c-5.332 0-9.67 4.411-9.67 9.856s4.329 9.857 9.67 9.857c5.342 0 9.67-4.412 9.67-9.857 0-5.445-4.325-9.857-9.67-9.857zm6.097 16.062a8.508 8.508 0 01-12.185 0c-3.36-3.425-3.36-8.983 0-12.409a8.508 8.508 0 0112.185 0c3.36 3.426 3.36 8.984 0 12.41z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#010101",
                        d: "M27.506 43.44c-5.406 0-9.804-4.483-9.804-9.994 0-5.51 4.398-9.991 9.804-9.991 5.406 0 9.804 4.483 9.804 9.991s-4.398 9.995-9.804 9.995zm0-19.716c-5.258 0-9.537 4.361-9.537 9.722 0 5.36 4.279 9.723 9.537 9.723 5.259 0 9.537-4.362 9.537-9.723 0-5.36-4.278-9.722-9.537-9.722zm0 18.627a8.631 8.631 0 01-6.183-2.605 8.941 8.941 0 01-2.558-6.3c0-2.38.909-4.618 2.558-6.3a8.649 8.649 0 0112.372 0 8.941 8.941 0 012.559 6.3c0 2.38-.91 4.619-2.559 6.3a8.663 8.663 0 01-6.189 2.605zm.01-17.538a8.4 8.4 0 00-6.002 2.524 8.669 8.669 0 00-2.482 6.11c0 2.307.881 4.477 2.482 6.108a8.39 8.39 0 0011.997 0 8.668 8.668 0 002.482-6.109 8.668 8.668 0 00-2.482-6.109 8.37 8.37 0 00-5.996-2.524z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#EB7F58",
                        d: "M25.375 30.312c1.802-1.115 5.046-.389 5.046 1.027 0 .714 1.06.714 1.06 0 0-1.353-1.496-2.455-3.437-2.627l.03-.877a.535.535 0 00-.531-.551c-.338 0-.571.229-.571.542v.886c-.827.075-1.57.313-2.141.67-.774.485-1.263 1.168-1.263 1.957 0 2.076 1.942 2.367 3.883 2.649 1.483.216 2.97.441 2.97 1.578 0 1.384-3.16 2.107-4.973 1.07-.476-.268-.774-.616-.826-.982-.095-.702-1.133-.573-1.05.128.18 1.49 1.928 2.27 3.394 2.411v.886c0 .714 1.06.714 1.06 0l.03-.886c1.929-.185 3.415-1.287 3.415-2.627 0-2.076-1.94-2.367-3.882-2.649-1.483-.216-2.97-.442-2.97-1.578 0-.379.286-.745.752-1.027h.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#EB7F58",
                        d: "M27.497 39.75c-.329 0-.663-.23-.663-.67v-.765c-1.58-.185-3.213-1.02-3.395-2.514a.646.646 0 01.566-.742.648.648 0 01.746.576c.046.32.316.632.762.883 1.238.71 3.127.557 4.11-.032.303-.181.666-.488.666-.92 0-1.027-1.453-1.24-2.857-1.444-1.873-.272-3.996-.579-3.996-2.78 0-.798.47-1.534 1.324-2.073.571-.357 1.29-.588 2.08-.68v-.763c0-.392.298-.677.706-.677a.65.65 0 01.48.207.68.68 0 01.183.485l-.027.749c1.996.219 3.43 1.362 3.43 2.749 0 .88-1.323.88-1.323 0 0-.451-.384-.767-.707-.952-1.02-.586-2.924-.708-4.14.04-.436.264-.688.596-.688.912 0 1.03 1.453 1.24 2.857 1.443 1.873.273 3.996.58 3.996 2.78 0 1.379-1.432 2.525-3.419 2.75l-.028.767c0 .435-.334.664-.663.664v.006zm-3.394-4.428c-.022 0-.04 0-.062.003-.19.025-.368.172-.337.441.165 1.375 1.815 2.151 3.274 2.292l.12.013v1.008c0 .551.795.551.795 0l.037-1.008.117-.01c1.877-.178 3.292-1.249 3.292-2.492 0-1.97-1.83-2.236-3.765-2.514-1.444-.21-3.084-.448-3.084-1.713 0-.42.289-.827.817-1.143 1.336-.823 3.326-.664 4.408-.044.543.31.841.733.841 1.19 0 .551.796.551.796 0 0-1.252-1.425-2.323-3.314-2.492l-.126-.013.037-1.005a.409.409 0 00-.111-.288.39.39 0 00-.289-.125c-.264 0-.44.162-.44.407v1.008l-.119.01c-.798.071-1.517.297-2.085.65-.774.486-1.198 1.14-1.198 1.842 0 1.97 1.83 2.236 3.765 2.514 1.447.21 3.084.448 3.084 1.713 0 .445-.276.842-.795 1.155-1.045.623-3.014.815-4.374.035-.516-.294-.836-.676-.894-1.08-.034-.248-.209-.351-.387-.351l-.003-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#010101",
                        d: "M27.506 7.138c-6.997 0-13.343 2.89-17.938 7.577C3.001 21.416.452 31.37 3.278 40.648A26.326 26.326 0 006.57 47.57c.182.291.513.373.79.21l7.48-4.522a.605.605 0 00.171-.851c-4.561-6.285-3.944-15.07 1.508-20.632a15.34 15.34 0 0121.99 0c4.115 4.183 5.636 10.433 3.784 16.167a16.175 16.175 0 01-2.252 4.44c-.227.303-.147.698.148.873l7.479 4.522c.252.15.583.081.755-.176 2.894-4.29 4.448-9.337 4.448-14.616C52.868 18.71 41.512 7.138 27.506 7.138zM13.727 42.574L7.243 46.5c-4.893-7.612-5.268-17.425-.946-25.41l6.472 3.918c-2.915 5.573-2.537 12.368.961 17.566h-.003zm13.208-26.59c-5.67.197-10.714 3.287-13.607 8.018l-6.472-3.917c4.22-7.004 11.687-11.573 20.079-11.77v7.668zm1.143 0V8.314c8.391.197 15.858 4.769 20.078 11.773l-6.472 3.918c-2.893-4.722-7.924-7.822-13.606-8.02v-.003zm19.7 30.516l-6.484-3.926c3.499-5.21 3.864-11.996.962-17.566l6.471-3.918c4.322 7.985 3.944 17.801-.949 25.41z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#010101",
                        d: "M7.065 48a.713.713 0 01-.605-.357 26.44 26.44 0 01-3.308-6.958c-2.81-9.23-.387-19.219 6.32-26.07C14.29 9.705 20.694 7 27.507 7 41.565 7 53 18.66 53 32.989c0 5.276-1.545 10.355-4.472 14.695a.69.69 0 01-.931.213l-7.476-4.522a.694.694 0 01-.332-.47.753.753 0 01.148-.6 15.95 15.95 0 002.23-4.403c1.83-5.67.393-11.814-3.754-16.029a15.226 15.226 0 00-21.802 0c-5.357 5.461-5.998 14.253-1.496 20.456.117.166.157.376.117.577a.715.715 0 01-.325.47l-7.48 4.52a.71.71 0 01-.362.104zM27.506 7.27c-6.754.006-13.085 2.683-17.846 7.54C3.02 21.587.624 31.472 3.404 40.606a26.164 26.164 0 003.277 6.889c.144.232.396.297.611.169l7.476-4.521a.44.44 0 00.203-.295.475.475 0 00-.07-.363c-4.58-6.306-3.926-15.252 1.523-20.804a15.491 15.491 0 0122.176 0c4.218 4.287 5.68 10.534 3.818 16.304a16.165 16.165 0 01-2.273 4.478.487.487 0 00-.098.385.442.442 0 00.206.291l7.48 4.525c.193.119.448.06.577-.135 2.893-4.293 4.423-9.321 4.423-14.541 0-14.181-11.316-25.717-25.227-25.717V7.27zm20.315 39.412l-6.714-4.068.08-.119a17.075 17.075 0 00.952-17.428l-.059-.113 6.7-4.055.064.122a25.13 25.13 0 01-.955 25.551l-.07.107.002.003zm-6.336-4.152l6.253 3.788a24.847 24.847 0 00.94-25.04l-6.244 3.78a17.342 17.342 0 01-.95 17.472zM7.203 46.682l-.07-.107a25.136 25.136 0 01-.953-25.55l.065-.122 6.699 4.055-.059.112a17.029 17.029 0 00.953 17.425l.08.12-6.715 4.067zm-.857-25.407a24.867 24.867 0 00.94 25.044l6.254-3.79a17.314 17.314 0 01-.95-17.471l-6.244-3.78v-.003zm7.025 2.91l-6.7-4.056.071-.116C11.09 12.8 18.635 8.375 26.932 8.18h.135v7.935l-.13.006c-5.525.194-10.572 3.169-13.499 7.957l-.067.112v-.006zm-6.33-4.147l6.244 3.78c2.96-4.763 7.998-7.731 13.518-7.966v-7.4c-8.106.239-15.475 4.56-19.763 11.59v-.004zm34.6 4.146l-.067-.113c-2.934-4.79-7.98-7.762-13.5-7.956h-.129V8.177h.135c8.297.2 15.843 4.625 20.19 11.84l.07.115-6.699 4.055v-.003zm-13.428-8.332c5.513.235 10.55 3.203 13.517 7.966l6.245-3.78C43.687 13.012 36.318 8.691 28.212 8.453v7.402-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#010101",
                        d: "M38.917 12.85l-2.276 2.307-.743-.758c-.538-.535-1.34.291-.811.827l1.155 1.177c.23.222.583.222.81 0l2.676-2.727c.525-.548-.286-1.366-.811-.827z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#010101",
                        d: "M36.647 16.704a.721.721 0 01-.497-.204l-1.158-1.18c-.32-.326-.24-.752.006-1.005.245-.254.666-.342.992-.016l.65.664 2.182-2.214c.32-.326.737-.244.986.006.248.25.334.68.015 1.011l-2.675 2.728a.714.714 0 01-.5.203v.007zm-1.14-2.346c-.12 0-.236.06-.319.147-.154.157-.215.414-.006.624l1.155 1.177a.45.45 0 00.626 0l2.673-2.724c.209-.216.144-.473-.013-.63-.156-.156-.405-.219-.61-.006l-2.369 2.405-.835-.852a.424.424 0 00-.298-.134l-.004-.007zM18.362 15.38l-.642-.655.642-.655c.525-.548-.285-1.365-.81-.826l-.643.654-.642-.654c-.537-.536-1.339.278-.81.826l.641.655-.641.654c-.526.548.273 1.365.81.827l.642-.655.642.655c.538.535 1.34-.291.811-.827z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#010101",
                        d: "M15.877 16.516a.724.724 0 01-.507-.223c-.245-.25-.328-.68-.009-1.011l.547-.557-.547-.558c-.32-.335-.24-.76.006-1.011.246-.25.667-.332.992-.01l.547.558.547-.558c.32-.325.737-.244.986.007.249.25.335.68.012 1.011l-.547.558.547.557c.32.325.24.751-.006 1.005-.246.254-.666.341-.992.016l-.547-.558-.546.558a.68.68 0 01-.486.213l.003.003zm0-3.31a.441.441 0 00-.316.144c-.154.157-.215.413-.006.63l.734.748-.734.748c-.21.216-.148.473.006.63.153.156.405.219.617.006l.734-.749.735.749c.211.21.463.147.617-.013.153-.156.215-.413.006-.623l-.734-.748.734-.749c.209-.216.144-.472-.012-.629-.154-.156-.406-.22-.615-.006l-.734.748-.734-.748a.413.413 0 00-.3-.135l.002-.003zM49.323 30.8l-2.276 2.32-.743-.757c-.538-.536-1.34.278-.81.826l1.154 1.165a.56.56 0 00.81 0l2.676-2.727c.526-.548-.273-1.365-.81-.827z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#010101",
                        d: "M47.053 34.664a.71.71 0 01-.5-.213l-1.155-1.165c-.32-.335-.24-.76.006-1.01.246-.251.667-.333.992-.01l.651.663 2.184-2.226c.326-.325.747-.24.992.01.246.25.329.68.01 1.011l-2.676 2.727a.693.693 0 01-.5.213h-.004zm-1.142-2.342a.441.441 0 00-.317.144c-.153.157-.215.413-.006.63l1.155 1.164a.425.425 0 00.624 0l2.675-2.727c.209-.216.148-.473-.006-.63-.154-.156-.406-.219-.617-.006l-2.369 2.415-.838-.852a.413.413 0 00-.301-.135v-.003zM5.84 32.222l.641.654-.642.655c-.525.548.286 1.365.811.826l.642-.654.642.654c.538.536 1.34-.29.811-.826l-.642-.655.642-.654c.525-.548-.273-1.365-.81-.827l-.643.655-.642-.655c-.537-.535-1.339.291-.81.827z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#010101",
                        d: "M6.266 34.667a.726.726 0 01-.506-.219c-.25-.25-.335-.68-.013-1.011l.547-.558-.547-.557c-.32-.326-.24-.755.006-1.005.246-.254.667-.341.993-.013l.546.558.547-.558c.329-.325.746-.244.992.007.246.25.329.68.01 1.011l-.547.557.546.558c.32.325.24.754-.006 1.005-.246.254-.666.341-.992.016l-.547-.558-.546.558a.664.664 0 01-.483.212v-.003zm-.003-3.31c-.12 0-.236.06-.32.148-.153.156-.214.413-.005.623l.734.748-.734.749c-.21.216-.145.472.012.629.157.157.405.22.611.006l.734-.748.734.748c.212.213.464.148.618-.012.153-.157.215-.414.006-.623l-.734-.749.734-.748c.209-.216.147-.473-.006-.63-.154-.156-.406-.219-.618-.006l-.734.749-.734-.749a.424.424 0 00-.298-.134zM33.757 26.773l1.926-5.435c.264-.642-.55-1.118-.962-.608l-4.143 4.13"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#010101",
                        d: "M33.88 26.817l-.25-.09 1.927-5.436c.113-.279-.022-.482-.172-.573a.416.416 0 00-.562.1l-4.153 4.14-.185-.195 4.144-4.13a.679.679 0 01.894-.15c.258.16.445.501.28.905l-1.923 5.43z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2_2288",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H51V41H0z",
                        transform: "translate(2 7)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var creditRepair = (CreditRepair);

;// CONCATENATED MODULE: ./src/components/shared/combinedForm/icons/debtRelief.tsx


function DebtRelief() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "55",
        height: "55",
        fill: "none",
        viewBox: "0 0 55 55",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_2_2280",
                style: {
                    maskType: "alpha"
                },
                width: "55",
                height: "55",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H55V55H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2_2280)",
                mask: "url(#mask0_2_2280)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#EB7F58",
                        d: "M41.735 45.236a.91.91 0 01-.91-.91v-1.678h-2.973a.91.91 0 01-.908-.91c0-.5.408-.908.908-.908h4.53a2.324 2.324 0 100-4.652h-1.356c-1.406 0-2.7-.706-3.466-1.88a4.103 4.103 0 01-.285-3.983 4.109 4.109 0 013.212-2.364l.335-.043V26.21c0-.5.408-.91.909-.91.5 0 .909.41.909.91v1.679h2.973c.5 0 .909.408.909.909a.91.91 0 01-.909.909h-4.53a2.325 2.325 0 100 4.652h1.356c1.406 0 2.7.705 3.467 1.88a4.106 4.106 0 01.285 3.978 4.1 4.1 0 01-3.212 2.365l-.335.042v1.699a.91.91 0 01-.91.909v.004zM13.261 45.236a.91.91 0 01-.909-.91v-1.678H9.38a.91.91 0 01-.909-.91c0-.5.409-.908.91-.908h4.528a2.324 2.324 0 100-4.652h-1.355a4.12 4.12 0 01-3.466-1.884 4.106 4.106 0 01-.285-3.979 4.109 4.109 0 013.216-2.364l.334-.043V26.21c0-.5.409-.91.91-.91.5 0 .908.41.908.91v1.679h2.974c.5 0 .909.408.909.909a.91.91 0 01-.91.909h-4.529a2.324 2.324 0 100 4.652h1.356c1.406 0 2.7.705 3.466 1.88a4.106 4.106 0 01.285 3.978 4.1 4.1 0 01-3.212 2.365l-.335.042v1.699a.91.91 0 01-.909.909l-.004.004zM27.5 45.236a.91.91 0 01-.909-.91v-1.678h-2.973a.91.91 0 01-.91-.91c0-.5.41-.908.91-.908h4.529c.828 0 1.602-.447 2.014-1.163a2.343 2.343 0 000-2.327 2.337 2.337 0 00-2.014-1.163h-1.352c-1.405 0-2.7-.705-3.466-1.88a4.103 4.103 0 01-.285-3.982 4.109 4.109 0 013.216-2.364l.335-.043V26.21c0-.5.408-.91.909-.91.5 0 .909.41.909.91v1.679h2.973c.5 0 .909.408.909.909a.91.91 0 01-.909.909h-4.53a2.324 2.324 0 100 4.652h1.353c1.405 0 2.7.705 3.466 1.88a4.096 4.096 0 01.285 3.978 4.1 4.1 0 01-3.212 2.365l-.335.042v1.699a.91.91 0 01-.91.909l-.003.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#010101",
                        d: "M6.791 53a4.763 4.763 0 01-3.39-1.402A4.757 4.757 0 012 48.208V10.674c0-1.278.497-2.484 1.402-3.389a4.757 4.757 0 013.39-1.402H8.47v-.385a3.46 3.46 0 011.025-2.473A3.489 3.489 0 0111.967 2h1.294a3.46 3.46 0 012.473 1.024 3.473 3.473 0 011.025 2.473v.385h21.479v-.385a3.46 3.46 0 011.024-2.473A3.489 3.489 0 0141.735 2h1.294c.932 0 1.814.362 2.472 1.024a3.482 3.482 0 011.025 2.473v.385h1.679c1.282 0 2.484.497 3.39 1.402a4.763 4.763 0 011.401 3.39v37.531a4.763 4.763 0 01-1.402 3.39 4.811 4.811 0 01-3.389 1.401H6.791V53zm-2.973-4.791c0 .793.308 1.54.87 2.103.563.562 1.31.87 2.103.87H48.21c.782 0 1.548-.316 2.103-.87.562-.563.87-1.306.87-2.103V19.347H3.818V48.209zM6.79 7.7c-.793 0-1.54.308-2.103.87a2.954 2.954 0 00-.87 2.103v6.856h47.364v-6.856c0-.793-.308-1.54-.87-2.103a2.954 2.954 0 00-2.103-.87h-1.68v2.973c0 .932-.361 1.814-1.024 2.473a3.473 3.473 0 01-2.472 1.024h-1.294a3.46 3.46 0 01-2.473-1.024 3.466 3.466 0 01-1.024-2.473V7.7h-21.48v2.973a3.46 3.46 0 01-1.024 2.473 3.466 3.466 0 01-2.473 1.024h-1.294A3.46 3.46 0 019.5 13.146a3.466 3.466 0 01-1.025-2.473V7.7H6.791zm34.944-3.882c-.925 0-1.68.755-1.68 1.679v5.176c0 .925.755 1.68 1.68 1.68h1.294a1.68 1.68 0 001.68-1.68V5.497a1.69 1.69 0 00-.494-1.186 1.696 1.696 0 00-1.186-.493h-1.294zm-29.768 0c-.924 0-1.679.755-1.679 1.679v5.176c0 .925.755 1.68 1.68 1.68h1.293c.447 0 .87-.174 1.187-.493.316-.316.493-.74.493-1.187V5.497a1.68 1.68 0 00-1.68-1.68h-1.294z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2_2280",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H51V51H0z",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var debtRelief = (DebtRelief);

;// CONCATENATED MODULE: ./src/components/shared/combinedForm/icons/hro.tsx


function Hro() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "143",
        height: "144",
        fill: "none",
        viewBox: "0 0 143 144",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_201_76",
                style: {
                    maskType: "alpha"
                },
                width: "143",
                height: "144",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0.715H142.358V143.073H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_201_76)",
                mask: "url(#mask0_201_76)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M70.942 33.762c-5.098 0-9.247-4.146-9.247-9.247 0-5.102 4.15-9.248 9.247-9.248 5.097 0 9.247 4.15 9.247 9.248 0 5.097-4.15 9.247-9.247 9.247zm0-16.123a6.884 6.884 0 00-6.876 6.876 6.884 6.884 0 006.876 6.875 6.884 6.884 0 006.875-6.875 6.884 6.884 0 00-6.875-6.876zM71.012 97.176a1.19 1.19 0 01-.839-.347 1.174 1.174 0 01-.347-.838l.031-26.04a1.19 1.19 0 011.186-1.186c.655 0 1.186.534 1.186 1.185l-.032 26.04a1.19 1.19 0 01-1.185 1.186zM23.903 53.063c-5.721 0-10.374-4.653-10.374-10.374 0-5.722 4.653-10.374 10.374-10.374 5.721 0 10.374 4.652 10.374 10.374 0 5.721-4.653 10.374-10.374 10.374zm0-18.377c-4.415 0-8.003 3.592-8.003 8.003 0 4.41 3.592 8.003 8.003 8.003s8.003-3.592 8.003-8.003-3.592-8.003-8.003-8.003zM23.981 125.354a1.182 1.182 0 01-1.186-1.185l.032-29.688a1.187 1.187 0 012.371.004l-.035 29.688c0 .651-.534 1.181-1.186 1.181h.004zM117.926 53.063c-5.722 0-10.375-4.653-10.375-10.374 0-5.722 4.653-10.374 10.375-10.374 5.721 0 10.374 4.652 10.374 10.374 0 5.721-4.653 10.374-10.374 10.374zm0-18.377c-4.415 0-8.003 3.592-8.003 8.003 0 4.41 3.592 8.003 8.003 8.003 4.41 0 8.002-3.592 8.002-8.003s-3.592-8.003-8.002-8.003zM118.003 125.354a1.183 1.183 0 01-1.185-1.185l.031-29.688a1.187 1.187 0 012.371.004l-.035 29.688c0 .651-.534 1.181-1.185 1.181h.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M118.156 131.832c-8.502 0-18.194-1.618-20.675-5.23l-.117-.168h-52.44l-.117.168c-2.48 3.612-12.172 5.23-20.674 5.23-10.565 0-21.263-2.41-21.263-7.016 0-3.132 4.704-4.856 8.646-5.753l.305-.07V96.092l-.562.273a5.125 5.125 0 01-2.258.523 5.196 5.196 0 01-5.191-5.191V68.218c0-6.915 5.628-12.542 12.543-12.542h15.093c6.915 0 12.542 5.627 12.542 12.542v23.479a5.196 5.196 0 01-5.19 5.19 5.15 5.15 0 01-2.259-.522l-.561-.273v21.045l30.338-14.458-1.369-.148c-7.894-.846-12.605-3.077-12.605-5.975 0-2.898 4.107-4.356 7.55-5.156l.301-.07V71.623l-.538.222c-.57.234-1.17.355-1.786.355-2.59 0-4.7-2.106-4.7-4.695V46.912c0-6.146 5-11.15 11.15-11.15l10.971-.012c3.818-.015 6.919-3.135 6.903-6.953L82.15 16.32a4.705 4.705 0 014.7-4.703c2.593 0 4.7 2.106 4.7 4.7v15.366c0 5.694-3.199 11.08-8.347 14.056-.897.518-1.454 1.509-1.454 2.585l-.059 42.92.308.067c3.623.791 7.94 2.343 7.94 5.241 0 2.898-4.855 5.203-12.983 6.014l-1.392.14 30.276 14.431V96.088l-.561.273a5.128 5.128 0 01-2.258.523 5.197 5.197 0 01-5.191-5.191V68.214c0-6.914 5.627-12.542 12.542-12.542h15.093c6.915 0 12.543 5.628 12.543 12.542v23.479a5.196 5.196 0 01-5.191 5.19c-.78 0-1.541-.175-2.258-.522l-.562-.269v22.804l.308.066c4.154.885 9.103 2.621 9.103 5.85 0 4.606-10.698 7.016-21.263 7.016l.012.004zm-12.796-10.288c-4.076 1.01-5.815 2.293-6.065 3.085l-.039.121.039.12c.023.067.039.137.05.207l.012.078.04.066c.257.422 1.243 1.521 4.89 2.578 3.689 1.069 8.611 1.658 13.865 1.658 5.253 0 10.179-.589 13.864-1.658 3.967-1.154 5.028-2.418 5.028-2.983 0-.917-2.255-2.371-6.56-3.381l-.48-.114v2.847a1.185 1.185 0 11-2.371 0V68.944a1.185 1.185 0 112.371 0V91.7a2.82 2.82 0 005.639 0V68.222c0-5.608-4.563-10.171-10.171-10.171h-15.093c-5.608 0-10.171 4.563-10.171 10.171v23.479a2.82 2.82 0 005.639 0V68.944a1.185 1.185 0 112.371 0v55.224a1.185 1.185 0 11-2.371 0v-2.745l-.484.121h-.003zm-94.023 0c-4.82 1.197-6.096 2.663-6.096 3.272 0 .565 1.057 1.833 5.027 2.983 3.69 1.069 8.612 1.658 13.865 1.658 5.254 0 10.18-.589 13.865-1.658 3.966-1.154 5.027-2.418 5.027-2.983 0-.917-2.254-2.371-6.56-3.381l-.48-.114v2.847a1.185 1.185 0 11-2.37 0V68.944a1.185 1.185 0 112.37 0V91.7a2.821 2.821 0 002.82 2.82 2.821 2.821 0 002.82-2.82V68.222c0-5.608-4.563-10.171-10.171-10.171H16.36c-5.608 0-10.17 4.563-10.17 10.171v23.479a2.821 2.821 0 002.819 2.82 2.821 2.821 0 002.82-2.82V68.944a1.185 1.185 0 112.37 0v55.224a1.185 1.185 0 11-2.37 0v-2.745l-.484.121h-.008zm25.908-2.379l1.01.277c3.928 1.076 6.338 2.581 6.962 4.36l.093.261h51.668l.094-.261c.612-1.728 2.917-3.21 6.673-4.278l.994-.285-33.825-16.119-33.665 16.045h-.004zM59.71 93.892c-3.737.968-4.895 2.126-4.989 2.602l-.015.074.015.074c.27 1.38 5.983 3.845 16.42 3.845 10.436 0 16.157-2.476 16.419-3.865l.015-.074-.015-.074c-.117-.58-1.65-1.774-5.394-2.683l-.48-.117v2.317a1.19 1.19 0 01-2.028.838 1.174 1.174 0 01-.347-.838l.066-47.667c0-1.919 1.014-3.693 2.64-4.633 4.42-2.55 7.161-7.153 7.161-12.004V16.32a2.332 2.332 0 00-2.328-2.328 2.332 2.332 0 00-2.328 2.328l.042 12.473c.016 5.124-4.137 9.313-9.266 9.333l-3.424.011h-7.555c-4.84 0-8.779 3.94-8.779 8.78v20.591a2.332 2.332 0 002.329 2.329 2.332 2.332 0 002.328-2.329v-19.96a1.185 1.185 0 112.371 0v48.443a1.185 1.185 0 11-2.371 0v-2.227l-.488.124v.004z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_201_76",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H136.549V120.211H0z",
                        transform: "translate(2.87 11.621)"
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/shared/combinedForm/icons/payroll.tsx


function Payroll() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "143",
        height: "144",
        fill: "none",
        viewBox: "0 0 143 144",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_201_61",
                style: {
                    maskType: "alpha"
                },
                width: "143",
                height: "144",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0.715H142.358V143.073H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_201_61)",
                mask: "url(#mask0_201_61)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M93.124 74.757c-.133 0-.261 0-.393-.004-.137 0-.273-.004-.41-.004H19.32c-.141 0-.285.004-.426.004-.168 0-.34 0-.509-.016-1.98-.14-3.268-1.291-3.62-3.232-.12-.654-.12-1.36-.12-2.041v-.08-20.682V28.69c0-1.411.071-2.662.981-3.677.786-.878 1.544-1.267 2.462-1.27.301 0 .602-.009.902-.017.301-.008.602-.016.903-.016 12.341 0 45.3.008 45.3.008h2.017l1.66-2c1.22-1.464 2.418-2.912 3.613-4.36.417-.504.822-1.01 1.231-1.519.345-.429.69-.858 1.038-1.283 2.563-3.127 5.93-4.72 10-4.723 3.998-.004 7.996-.008 11.99-.008h17.874l.096-.052c.069-.04.129-.069.185-.097.14-.068.297-.144.397-.308 1.483-2.494 3.681-3.705 6.728-3.705h.281c1.812.044 3.729.064 5.858.064 1.78 0 3.689-.012 6.183-.044h.056c1.511 0 3.54.806 4.282 3.071.213.65.217 1.42.217 2.161v.089c.016 4.767.016 9.534.016 14.302v7.835c0 2.995-.008 6.09.008 9.134.012 2.069-.83 3.484-2.571 4.33a4.646 4.646 0 01-1.936.45c-2.322.023-4.82.043-7.33.043-2.065 0-3.925-.016-5.689-.044-2.45-.04-4.415-1.167-5.842-3.34-.165-.248-.309-.505-.478-.802-.084-.144-.168-.297-.26-.453l-.117-.2h-4.715l-.104.244c-.072.165-.136.329-.205.49-.14.336-.268.657-.421.962-1.423 2.87-3.652 4.298-6.82 4.354-.573.012-1.147.016-1.724.016-.473 0-.95 0-1.44-.004-.509 0-1.03-.004-1.567-.004h-.377l-.024.377a82.2 82.2 0 01-.049.658c-.031.425-.064.822-.064 1.223-.004 4.719-.004 9.434-.008 14.154V70.046c0 .396.008.77-.02 1.146-.14 1.977-1.503 3.368-3.472 3.545-.188.016-.377.02-.565.02zm-72.45-47.723c-.526 0-1.059.024-1.572.044l-.249.012a.566.566 0 00-.38.193c-.06.056-.105.096-.137.128l-.12.116-.028.193v43.348l.312.072c.995.225 25.71.309 42.081.309h.004c15.12 0 31.693-.064 32.86-.24l.34-.053V35.943l-.473.085c-1.335.24-2.137 1.038-2.919 1.808-.674.67-1.323 1.335-1.949 1.985-1.287 1.335-2.622 2.714-4.045 3.925-1.616 1.375-3.5 2.101-5.441 2.101-3.65 0-7.01-2.502-7.984-5.95-.914-3.224-.292-5.958 1.901-8.356.75-.822 1.504-1.64 2.261-2.462l1.3-1.411-.397-.261a4.142 4.142 0 01-.189-.136c-.132-.1-.268-.209-.469-.209-18.24-.016-36.48-.024-54.72-.028h.013zm79.442 8.873c-.38 0-.761 0-1.142.008a6.304 6.304 0 00-.975.113c-.156.024-.316.052-.489.076l-.349.048v1.664c0 .958-.004 1.877 0 2.795.008.91.028 1.816.048 2.758l.032 1.656h.394c.5 0 .978 0 1.439.004.433 0 .85.004 1.263.004.517 0 1.026-.004 1.532-.016 2.758-.072 4.065-1.167 4.659-3.893.429-1.977.886-2.354 2.863-2.386.557-.008 1.11-.012 1.684-.012.445 0 2.41.008 2.967.008h.401v-1.19-1.26c-.028-7.41-.056-14.82-.088-22.23 0-.143-.056-.28-.169-.424a.846.846 0 00-.188-.169l-.064-.048-.036-.02a.637.637 0 00-.353-.124c-8.212.008-16.424.016-24.636.028h-.336c-1.56 0-3.12.004-4.675.02-2.166.024-4.01.786-5.341 2.21-1.488 1.591-2.871 3.247-4.339 5.003-.63.75-1.267 1.516-1.928 2.294l-.458.537.694.12c.237.04.433.08.61.117.332.068.593.12.866.124.204 0 .413.004.617.004.325 0 .654 0 .978-.008.325 0 .65-.008.97-.008.638 0 1.156.012 1.62.044.109.008.213.012.317.012 1.191 0 2.11-.44 2.972-1.427 1.575-1.809 3.251-3.493 4.538-4.764.361-.357.742-.537 1.131-.537.345 0 .698.148 1.023.425.701.601.81 1.584.252 2.338-.417.565-.918 1.094-1.399 1.612l-.152.16c-1.608 1.712-3.22 3.424-4.832 5.136a3160.943 3160.943 0 00-5.048 5.37l-.225.24c-.61.645-1.239 1.315-1.792 2.033a4.884 4.884 0 00-.978 3.74 4.999 4.999 0 002.08 3.365c.879.621 1.877.95 2.892.95 1.359 0 2.714-.593 3.813-1.668a197.257 197.257 0 005.36-5.421c1.745-1.844 3.734-2.743 6.075-2.743.124 0 .249 0 .377.008.93.037 1.949.056 3.116.056 1.002 0 2.004-.012 3.007-.024.569-.008 1.139-.016 1.708-.02.337 0 .67-.076.986-.148.145-.032.289-.064.441-.092l.301-.056.028-.305c.02-.212.032-.413.048-.605.028-.39.048-.722.109-1.047.168-.914.689-1.36 1.599-1.36h.105c.942.037 1.451.53 1.543 1.516.052.55.06 1.151.016 1.941-.112 2.073-1.387 3.36-3.42 3.44-.802.032-1.604.036-2.217.036h-1.841l-.004-.008zm21.769-26.932c-1.203 0-2.322.48-3.076 1.319-.697.778-1.006 1.768-.89 2.863.02.196.016.405.008.621 0 .112-.008.225-.008.333V39.127c-.004.401-.008.814.028 1.231.141 1.608 1.163 2.79 2.735 3.164.493.116.99.18 1.471.18 2.707.016 5.409.028 8.116.028.894 0 1.792 0 2.686-.004.469 0 .923-.068 1.404-.136.216-.032.437-.064.665-.088l.309-.037.044-.308c.381-2.767.293-32.013-.1-33.653l-.064-.26-.265-.04c-.116-.02-.24-.045-.365-.069-.3-.06-.637-.128-.986-.128h-1.007c-.994 0-1.988 0-2.979.008-.99.004-1.984.008-2.975.008-1.812 0-3.284-.016-4.631-.052h-.116l-.004.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M32.133 137.648c-.902 0-1.796-.413-2.514-1.159-2.807-2.911-5.726-5.81-8.548-8.613-1.16-1.15-2.318-2.301-3.473-3.456l-12.89-12.891c-.101-.1-.201-.2-.305-.297-.285-.276-.554-.533-.782-.822-.87-1.082-.91-2.257-.117-3.396.197-.28.445-.529.71-.794l.044-.044c1.432-1.435 2.867-2.867 4.303-4.302 1.92-1.92 3.84-3.837 5.753-5.758 1.716-1.72 3.553-2.558 5.614-2.558.766 0 1.572.12 2.394.357.204.06.409.076.621.092.1.008.213.016.333.032l.224.028.14-.176.297-.37c.221-.272.454-.552.662-.853 4.559-6.52 10.826-10.301 18.629-11.24a23.565 23.565 0 012.803-.168c3.404 0 6.772.778 10.012 2.31a13.355 13.355 0 005.83 1.307h.132c1.636-.016 3.272-.02 4.904-.02 1.11 0 5.549.008 6.66.008 2.23 0 4.03-.008 5.665-.024h.249c3.123 0 5.377.69 7.297 2.241l.277.22 4.322-4.173c3.152-3.047 6.251-6.035 9.339-9.038 1.804-1.756 3.813-2.642 5.966-2.642.618 0 1.259.072 1.905.216 2.855.638 5.12 2.63 6.062 5.337.955 2.739.405 5.746-1.463 8.052-2.675 3.3-5.353 6.591-8.035 9.887a4837.69 4837.69 0 00-12.787 15.766c-1.825 2.262-4.01 3.316-6.88 3.316h-.077c-2.759-.02-5.698-.028-9.53-.028l-9.977.004c-4.013 0-7.08-.008-9.948-.028h-.06c-2.819 0-6.868 1.439-8.825 4.102l-.084.112.024.646c.016.425.032.894.064 1.359.169 2.329-.585 4.298-2.297 6.022a765.258 765.258 0 01-3.252 3.244c-2.334 2.318-4.744 4.715-7.057 7.129-.662.694-1.472 1.059-2.338 1.059l.004.004zm-12.069-40.06c-.95 0-1.88.433-2.767 1.287-2.233 2.153-4.402 4.294-6.696 6.555-.946.935-1.9 1.877-2.87 2.827l-.29.285 24.696 24.679.285-.284c.966-.975 1.92-1.929 2.863-2.875 2.333-2.338 4.535-4.543 6.736-6.829 1.46-1.515 1.451-3.572-.02-5.24a10.8 10.8 0 00-.598-.61c-.088-.088-.18-.172-.268-.26l-3.312-3.312a62899.12 62899.12 0 00-8.168-8.168c-.718-.718-1.435-1.444-2.149-2.165a248.98 248.98 0 00-4.519-4.5c-.954-.921-1.936-1.386-2.923-1.386v-.004zm26.05-12.302c-.164 0-.332 0-.496.008-5.895.165-10.99 2.37-15.149 6.556-1.76 1.772-2.83 3.296-3.472 4.936l-.088.224.16.185c3.328 3.833 15.998 16.291 17.382 17.093l.24.14.217-.176c4.479-3.681 6.155-4.283 11.973-4.287 2.273 0 4.542 0 6.816-.004 2.626 0 5.253-.004 7.879-.004 5.417 0 9.599.012 13.569.032h.044c1.776 0 3.071-.629 4.202-2.045 3.247-4.069 6.596-8.175 9.831-12.145a6933.57 6933.57 0 0010.61-13.06c.641-.793 1.459-2.032 1.147-3.64-.417-2.141-2.061-3.58-4.086-3.58-1.027 0-2.021.38-2.875 1.102-.834.706-1.62 1.48-2.382 2.234-.277.272-.553.549-.834.817-2.747 2.659-5.493 5.321-8.256 7.996l-3.304 3.2.04.212c.518 2.79-.104 5.413-1.744 7.382-1.648 1.98-4.114 3.075-6.936 3.075h-.177c-2.017-.036-4.19-.048-6.84-.048-1.664 0-3.328.004-4.992.012-1.664.004-3.324.012-4.988.012h-.934c-.47 0-.959 0-1.38-.112-1.026-.269-1.584-1.059-1.491-2.117.092-1.083.701-1.66 1.856-1.76.357-.033.718-.037 1.026-.037h.73l7.891.004c2.92 0 5.838 0 8.757-.016.97-.004 1.78-.104 2.478-.308 1.805-.526 3.08-2.398 2.903-4.255-.18-1.936-1.612-3.492-3.48-3.785-.594-.092-1.191-.1-1.752-.1H69.363c-2.502 0-5 0-7.502-.008-2.71-.008-4.992-.51-6.973-1.532-2.827-1.46-5.778-2.197-8.765-2.197l-.008-.004zM55.894 63.49c-.625 0-1.094-.437-1.219-1.143-.064-.373-.072-.77-.08-1.155 0-.176-.004-.349-.016-.517l-.012-.26-.245-.093a37.893 37.893 0 00-1.327-.481c-.97-.34-1.884-.666-2.73-1.119-.598-.32-.943-.822-.943-1.367 0-.601.41-1.179 1.091-1.544.152-.08.337-.132.553-.188.065-.016.125-.032.189-.052 1.263.637 2.622 1.243 4.174 1.243.22 0 .449-.012.67-.036 1.178-.137 1.916-.662 2.313-1.66.433-1.091.168-2.114-.762-2.96-.533-.485-1.163-.846-1.772-1.194l-.116-.065a36.765 36.765 0 00-1.404-.757c-.525-.277-1.066-.562-1.58-.863-2.49-1.471-3.512-3.263-3.211-5.645.325-2.586 1.728-4.266 4.162-4.988.152-.044.284-.112.44-.188.073-.037.15-.077.237-.117l.217-.1.016-.237c.012-.196.02-.396.028-.597.016-.433.036-.882.1-1.307.105-.702.541-1.095 1.235-1.099.746 0 1.09.313 1.207 1.075.068.437.104.894.14 1.295.017.176.029.349.044.51l.025.236.216.092c.357.152.698.289 1.023.42.69.278 1.287.514 1.844.83.55.306.914.727 1.038 1.18.097.36.037.741-.172 1.094-.24.405-.734.842-1.391.842-.273 0-.558-.076-.846-.228a7.078 7.078 0 00-2.607-.762c-.108-.008-.212-.016-.312-.016-1.171 0-2.097.637-2.47 1.704-.43 1.219-.02 2.23 1.215 3 .862.537 1.78 1.002 2.666 1.455.41.208.822.417 1.227.633 1.544.818 2.526 1.708 3.188 2.883.73 1.3.842 3.052.292 4.691-.533 1.596-1.6 2.811-2.995 3.417-.373.164-.75.32-1.135.485l-.75.32-.023.233c-.024.217-.044.433-.065.646-.044.46-.084.894-.16 1.319-.132.73-.57 1.15-1.199 1.155h-.012l.004-.02zM38.81 51.4c-.538 0-1.1-.268-1.54-.741-.438-.47-.678-1.067-.642-1.604.076-1.155 1.014-1.989 2.23-1.989h.068a2.11 2.11 0 011.487.654c.385.409.585.95.57 1.527-.037 1.147-1.051 2.15-2.174 2.15v.004zM73.023 51.389c-1.174-.037-2.053-.987-2.04-2.218.011-1.227.89-2.117 2.093-2.117.605 0 1.162.237 1.571.666.417.433.634 1.002.61 1.612-.04 1.094-1.055 2.057-2.178 2.057h-.056zM124.495 17.876c-1.255 0-2.277-.962-2.37-2.237-.04-.534.181-1.111.602-1.58.469-.521 1.102-.834 1.74-.858h.08c1.215 0 2.222.954 2.294 2.173.084 1.431-.774 2.414-2.19 2.498-.052 0-.104.004-.156.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M20.409 109.143a2.38 2.38 0 01-2.322-2.429c.016-1.348 1.01-2.326 2.362-2.326.642.004 1.267.289 1.732.778.437.461.678 1.042.658 1.604-.048 1.243-1.18 2.373-2.37 2.373h-.06z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_201_61",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H135.975V131.985H0z",
                        transform: "translate(2.939 5.663)"
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/shared/combinedForm/icons/peo.tsx


function Peo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "143",
        height: "144",
        fill: "none",
        viewBox: "0 0 143 144",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_201_59",
                style: {
                    maskType: "alpha"
                },
                width: "143",
                height: "144",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0.715H142.358V143.073H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_201_59)",
                mask: "url(#mask0_201_59)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M12.815 130.561c-4.85 0-8.797-3.947-8.797-8.797V35.611c0-4.85 3.947-8.797 8.797-8.797h44.59V14.033a2.417 2.417 0 012.412-2.412h21.669a2.417 2.417 0 012.412 2.412v12.786H129.8c4.85 0 8.797 3.947 8.797 8.797v48.697h-4.818V35.611a3.983 3.983 0 00-3.979-3.979H83.998l-.239 1.647c-.94 6.46-6.57 11.33-13.105 11.33-6.534 0-12.165-4.87-13.105-11.33l-.239-1.647H12.815a3.983 3.983 0 00-3.979 3.979v86.158c0 1.063.415 2.061 1.169 2.81a3.96 3.96 0 002.81 1.164h67.82v4.818h-67.82zM62.23 31.366c0 4.649 3.777 8.425 8.425 8.425 4.648 0 8.425-3.776 8.425-8.425V16.44H62.235v14.927h-.006z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M110.841 132.68a2.396 2.396 0 01-1.456-.494l-18.858-14.412a2.41 2.41 0 112.933-3.83l17.062 13.047 23.868-27.135a2.407 2.407 0 011.811-.818c.59 0 1.153.213 1.594.6a2.418 2.418 0 01.218 3.406l-25.35 28.824a2.405 2.405 0 01-1.806.818h-.011l-.005-.006zm-87.146-24.818a2.413 2.413 0 01-2.412-2.412v-8.053c0-.924.536-1.774 1.37-2.173l18.736-8.972-5.535-7.782a2.39 2.39 0 01-.446-1.397V64.387c0-8.34 6.683-14.874 15.214-14.874s15.214 6.534 15.214 14.874v12.686c0 .488-.149.961-.425 1.365l-5.381 7.83 17.95 8.972a2.394 2.394 0 011.333 2.157v8.053a2.417 2.417 0 01-2.412 2.412H23.695zm26.927-53.526c-5.827 0-10.396 4.415-10.396 10.056v11.916l6.747 9.487c.414.58.547 1.312.371 2.003a2.388 2.388 0 01-1.29 1.567l-19.948 9.551v4.128h48.389V98.89l-19.097-9.541a2.402 2.402 0 01-1.254-1.551 2.423 2.423 0 01.345-1.971l6.529-9.498V64.392c0-5.636-4.563-10.056-10.396-10.056zM88.795 84.58a2.413 2.413 0 01-2.411-2.412 2.413 2.413 0 012.411-2.412h17.61a2.417 2.417 0 012.412 2.412 2.417 2.417 0 01-2.412 2.412h-17.61zm0-18.37a2.413 2.413 0 01-2.411-2.412 2.413 2.413 0 012.411-2.411h27.576a2.417 2.417 0 012.412 2.411 2.417 2.417 0 01-2.412 2.412H88.795z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_201_59",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H134.584V121.059H0z",
                        transform: "translate(4.018 11.621)"
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/shared/combinedForm/icons/taxDebtRelief.tsx


function TaxDebtRelief() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "55",
        height: "55",
        fill: "none",
        viewBox: "0 0 55 55",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                style: {
                    maskType: "alpha"
                },
                width: "55",
                height: "55",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H55V55H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2_2317)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#010101",
                        d: "M7.642 34.843l-5.45-15.468c-.613-1.75.284-3.695 2-4.336L36.309 3.215a3.3 3.3 0 012.556.092 3.348 3.348 0 011.738 1.892l4.59 12.695-1.354.494-4.587-12.692a1.9 1.9 0 00-.985-1.074 1.878 1.878 0 00-1.458-.049L4.69 16.398c-.982.365-1.495 1.484-1.14 2.496L9 34.36l-1.358.485v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#010101",
                        d: "M13.239 52c-4.679 0-8.485-3.84-8.485-8.556 0-4.256 3.007-7.813 7.155-8.46l.348-.055V23.03c0-1.767 1.497-3.205 3.34-3.205H49.76c1.784 0 3.239 1.438 3.239 3.205v21.202c0 1.824-1.452 3.305-3.239 3.305H20.687l-.12.2C18.973 50.366 16.165 52 13.24 52zm0-15.903c-4.014 0-7.28 3.297-7.28 7.344 0 4.048 3.266 7.345 7.28 7.345 4.013 0 7.28-3.297 7.28-7.345 0-4.047-3.267-7.344-7.28-7.344zm.222-1.214l.382.027c4.419.32 7.88 4.067 7.88 8.531 0 .81-.112 1.601-.338 2.352l-.159.534h28.535c.54 0 1.052-.22 1.44-.622.384-.4.594-.92.594-1.472v-13.77H13.461v4.42zm2.135-13.846c-1.177 0-2.135.896-2.135 1.994v2.91h38.334v-2.91c0-1.12-.893-1.994-2.034-1.994H15.596z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#EB7F58",
                        d: "M11.665 47.109a.513.513 0 01-.4-.166l-2.933-2.95a.6.6 0 010-.867.604.604 0 01.43-.184c.158 0 .314.064.43.184l2.47 2.483 5.615-5.67a.604.604 0 01.43-.184c.159 0 .314.065.43.184a.6.6 0 010 .868l-6.057 6.09c-.134.132-.287.212-.418.212h.003z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2_2317",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H51V49H0z",
                        transform: "translate(2 3)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var taxDebtRelief = (TaxDebtRelief);

;// CONCATENATED MODULE: ./src/components/shared/combinedForm/staticContentMap.tsx







const map = {
    "tax-debt-relief": {
        label: "Resolving Tax Debt",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(taxDebtRelief, {})
    },
    "debt-relief": {
        label: "Managing My Debt",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(debtRelief, {})
    },
    "credit-repair": {
        label: "Repairing My Credit Score",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(creditRepair, {})
    },
    peo: {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Peo, {}),
        description: "This solution is for SMBs looking to collaborate with a co-employment provider to share liabilities, and take a more active role in managing HR responsibilities."
    },
    "payroll-services": {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Payroll, {}),
        description: "This solution is ideal for businesses seeking straightforward payroll software that automatically updates tax regulations, provides task reminders for employers, and demands minimal user input."
    },
    hro: {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hro, {}),
        description: "This solution is ideal for large companies with HR staff who need \xe0 la carte offerings to manage things like policy-making, payroll, and employee benefits."
    }
};
map["peo-employee-leasing"] = map["peo"];
map["employee-leasing"] = map["peo"];
map["payroll"] = map["payroll-services"];
/* harmony default export */ var staticContentMap = (map);

// EXTERNAL MODULE: ./src/components/shared/combinedForm/icons/caret.tsx
var caret = __webpack_require__(37814);
;// CONCATENATED MODULE: ./src/components/shared/combinedForm/index.tsx










function CombinedForm({ primaryColor , formClasses , mainBannerClassName , colors , backButtonClassName , title , description , blockClassName , blockContainerClassName , mainTitleClassName , descriptionClassName , secondaryTitleClassName , secondaryDescriptionClassName , question , showArrows , resetLeadId  }) {
    const { form , updateForm , formattedTitle , domain  } = (0,useDomainContext/* useDomainContext */.w)();
    const categories = domain?.categories;
    const { 0: isFormFetched , 1: updateFormFetched  } = (0,react.useState)(false);
    const { 0: currentStep , 1: setCurrentStep  } = (0,react.useState)(0);
    const { 0: formError , 1: updateFetchFormError  } = (0,react.useState)(null);
    const getForm = async (categorySlug)=>{
        const { data , error  } = await (0,api/* getDomainForm */.OU)({
            categorySlug
        });
        if (error) {
            // @ts-ignore
            updateFetchFormError(error);
        }
        if (data) {
            updateFetchFormError(null);
            updateForm(data);
            updateFormFetched(true); // display form component
            setCurrentStep(1); // move next step
        }
    };
    const formContent = (0,react.useMemo)(()=>isFormFetched ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_form/* default */.Z, {
                classes: formClasses,
                colors: colors ?? {},
                showProgress: true,
                progressShift: 1,
                backButton: {
                    class: `${(style_module_default())["back-button"]} ${backButtonClassName ?? ""}`,
                    // label: "Back",
                    firstStepAction: ()=>{
                        setCurrentStep(0);
                    }
                },
                preventWindowClose: true,
                resetLeadId: resetLeadId,
                stepsConfig: [
                    {
                        stepOrder: 0,
                        hideTitle: false,
                        hideDescription: false,
                        forceStepTitle: true
                    }, 
                ]
            })
        }, form?.title) : null, [
        isFormFetched,
        form
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: mainBannerClassName,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: `${(style_module_default()).mainBannerWrapper}`,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(style_module_default()).formWrapper}`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `${(style_module_default()).formStepsWrapper}`,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            transform: `translate(${currentStep * -100}%, 0)`
                        },
                        className: `${(style_module_default()).formStepsWrapperWindow}`,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(style_module_default()).stepBlock}`,
                                children: currentStep === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: `${(style_module_default()).outsideBrief} ${mainTitleClassName ? mainTitleClassName : "text-base md:text-2xl"} font-bold  px-3.5 md:px-0 mx-auto mb-6  text-center`,
                                                    dangerouslySetInnerHTML: {
                                                        __html: formattedTitle ?? title ?? ""
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: `${(style_module_default()).outsideBrief} font-bold  px-3.5 md:px-0 mx-auto mb-6 text-base md:text-2xl text-center`,
                                                    children: question
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: `${(style_module_default()).outsideTitle} ${descriptionClassName ? descriptionClassName : "max-w-xl"}  mx-auto  md:px-0 text-center mb-4`,
                                                    children: description
                                                })
                                            ]
                                        }),
                                        formError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (style_module_default()).errorMessage,
                                            children: "Something went wrong"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: `${(style_module_default()).serviceBlocks} flex text-lg mx-auto ${blockContainerClassName ?? ""}`,
                                            style: {
                                                "--primary-color": primaryColor
                                            },
                                            children: categories?.map((item)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: `flex flex-col items-center justify-center text-center  rounded-lg mb-4  mx-2 ${blockClassName ?? ""}`,
                                                    onClick: ()=>void getForm(item.slug),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mb-3",
                                                            children: staticContentMap[item.slug]?.icon ?? /*#__PURE__*/ (0,jsx_runtime.jsx)(creditRepair, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: `${secondaryTitleClassName ? secondaryTitleClassName : "text-base"}   block  w-full`,
                                                                    children: staticContentMap[item.slug]?.label ?? item.label ?? item.name
                                                                }),
                                                                staticContentMap[item.slug]?.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: `${secondaryDescriptionClassName ? secondaryDescriptionClassName : ""} relative flex`,
                                                                    children: staticContentMap[item.slug]?.description
                                                                })
                                                            ]
                                                        }),
                                                        showArrows && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: `${(style_module_default()).caret} absolute md:relative bottom-2 right-1 w-5 md:w-10 mt-4`,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(caret/* default */.Z, {})
                                                        })
                                                    ]
                                                }, item.slug);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(progressBar/* default */.Z, {
                                            className: `${(style_module_default())["progress-bar"]} ${(style_module_default())["custom-progress"]}`,
                                            current: 0,
                                            total: 8,
                                            color: colors?.primaryColor
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(style_module_default()).stepBlock}`,
                                children: currentStep === 1 && formContent
                            })
                        ]
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 96119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ResolvedForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);



const FormNew = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(33646), __webpack_require__.e(44268), __webpack_require__.e(26569), __webpack_require__.e(198), __webpack_require__.e(3294), __webpack_require__.e(15818), __webpack_require__.e(14086), __webpack_require__.e(47341)]).then(__webpack_require__.bind(__webpack_require__, 47341)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(47341)
            ]
    }
});
const FormOld = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(33646), __webpack_require__.e(44268), __webpack_require__.e(26569), __webpack_require__.e(198), __webpack_require__.e(3294), __webpack_require__.e(15818), __webpack_require__.e(14086), __webpack_require__.e(75108)]).then(__webpack_require__.bind(__webpack_require__, 75108)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(75108)
            ]
    }
});
function ResolvedForm(props) {
    const { loadOneToOneForm , domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    // The new form is the default for every domain. Keep the legacy form
    // available as an explicit per-domain escape hatch while one-to-one flows,
    // which are only implemented by the new form, always stay on FormNew.
    const useOldForm = !loadOneToOneForm && domain?.config?.forceOldForm === true;
    return useOldForm ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormOld, {
        ...props
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormNew, {
        ...props
    });
}


/***/ }),

/***/ 91354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProgressBar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90796);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);




function ProgressBar({ total , current , className , color , backgroundColor , shift =0 , showStepNumberOnly =false , mode ="continuous" , title ="" , titleIcon , activeSegmentClassName =""  }) {
    const progress = (current + shift) / (total + shift - 1);
    const progressPercentage = Math.round(progress * 100);
    const hideStepsNumber = current + shift + 1 > total + shift - 1;
    if (mode === "steps") {
        const activeIndex = current + shift;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["top-progress-bar"])} ${className} ${activeIndex >= total - 1 ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().success) : ""}`,
            style: {
                backgroundColor
            },
            children: [
                (title || titleIcon) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["progress-title"]),
                    children: [
                        titleIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["title-icon"]),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: titleIcon,
                                alt: title ?? "form icon",
                                height: "50px",
                                width: "50px"
                            })
                        }),
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                            children: title
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().segments),
                    children: Array.from({
                        length: total
                    }).map((_, index)=>{
                        const isActive = index <= activeIndex;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().segment)} ${isActive ? `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["active-segment"])} progressStepActive ${activeSegmentClassName}` : (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["inactive-segment"])}`
                        }, index);
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["progress-bar"])} ${className} ${progressPercentage === 100 ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().success) : ""}`,
        children: !showStepNumberOnly ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        left: progressPercentage ? `${progressPercentage}%` : 0,
                        transform: "translateX(-50%)",
                        background: color
                    },
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().percentage),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "text-xs",
                            children: [
                                progressPercentage,
                                "%"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: {
                                borderBottomColor: color
                            },
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().arrow)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bar),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        style: {
                            width: `${progressPercentage}%`,
                            background: color
                        }
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: !hideStepsNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["step-number"]),
                children: [
                    current + shift + 1,
                    " of ",
                    total + shift - 1
                ]
            })
        })
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 48378:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"facebook":"styles_facebook__EYfOu","twitter":"styles_twitter__47r59","pintrest":"styles_pintrest__w6OTr"};

/***/ }),

/***/ 25086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"linkColor":"style_linkColor__aZ9m3","linksList":"style_linksList__xLuOw","bulletedListItem":"style_bulletedListItem__H1JoX"};

/***/ }),

/***/ 34480:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","desc":"style_desc__q6Szb","icon":"style_icon__MSg4r","lnkTitle":"style_lnkTitle__N0Os_","region":"style_region__kur8V","serviceBlocks":"style_serviceBlocks__8TQxv","mainBanner":"style_mainBanner__cDE_m","errorMessage":"style_errorMessage__QvmPp","form":"style_form__qH_QS","form-step-0":"style_form-step-0__UVE2Y","formWrapper":"style_formWrapper__v1IC_","mainTitle":"style_mainTitle__TLu7Q","form-button":"style_form-button__kCl_g","form-field":"style_form-field__lkbH3","back-button":"style_back-button__H5AGS","selling-point":"style_selling-point__Bw_4v","bestLawyer":"style_bestLawyer__s_V7J","steps-inner":"style_steps-inner__eS2H6","fields-wrapper":"style_fields-wrapper__eJ4Jl","step-block":"style_step-block__hlsp8","step-title":"style_step-title__rCzQw","label-as-step-title":"style_label-as-step-title__oE5ND","step-description":"style_step-description__Q_49o","outsideBrief":"style_outsideBrief__3FBKn","submit-button":"style_submit-button__5Jx9B","blink":"style_blink__uyp5M","custom-progress":"style_custom-progress__p0VO4","mainBannerWrapper":"style_mainBannerWrapper__g8oCq","formStepsWrapper":"style_formStepsWrapper__PFrV4","stepBlock":"style_stepBlock__PmCQM","title":"style_title__lZRCA","brief":"style_brief__g5vFG","buttons":"style_buttons__JopnM","formStepsWrapperWindow":"style_formStepsWrapperWindow__0EdAX","description":"style_description___Ly52","progress-bar":"style_progress-bar__a2Vul","caret":"style_caret__Am_5r"};

/***/ }),

/***/ 90796:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","progress-bar":"styles_progress-bar__t428f","percentage":"styles_percentage__i1uhQ","arrow":"styles_arrow__EMmUy","bar":"styles_bar__g1uQX","segments":"styles_segments__tu7RY","segment":"styles_segment__JDFf_","top-progress-bar":"styles_top-progress-bar__eqW56","progress-title":"styles_progress-title__qNbAM"};

/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ })

}]);